import { Scene } from "@babylonjs/core/scene";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Animation } from "@babylonjs/core/Animations/animation";
import { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";
import { performMarkJitter } from "common/model/animations/character/mark";
import { JITTER_FRAMES } from "./constants";

// 衝突アニメ：前後方向に小さく振動 + 頭上「！」マーク。原地から動かない。
// fwd: world 座標系での前方ベクトル（ボックスを押す方向）。
// mark mesh が scene に存在しない場合は振動のみ（safely fallback）。
// speedRatio: アニメ速度倍率（デフォルト 1.0）
export const performCharBump = (
  scene: Scene,
  node: AbstractMesh,
  fwd: { dx: number; dz: number },
  speedRatio = 1,
): Promise<void> =>
  new Promise<void>((resolve) => {
    if (!scene || scene.isDisposed) return resolve();

    if (scene.getMeshByName("mark")) {
      performMarkJitter(scene, node, JITTER_FRAMES);
    }

    const start = node.position.clone();
    const anim = new Animation(
      "charBump",
      "position",
      JITTER_FRAMES,
      Animation.ANIMATIONTYPE_VECTOR3,
      Animation.ANIMATIONLOOPMODE_CONSTANT,
    );
    const keys = [];
    for (let i = 0; i <= JITTER_FRAMES; i++) {
      const sign = i % 2 === 0 ? 0.1 : -0.1;
      keys.push({
        frame: i,
        value: new Vector3(start.x + sign * fwd.dx, start.y, start.z + sign * fwd.dz),
      });
    }
    keys[keys.length - 1].value = start.clone();
    anim.setKeys(keys);

    const a = scene.beginDirectAnimation(node, [anim], 0, JITTER_FRAMES, false, speedRatio);
    a.onAnimationEnd = () => resolve();
  });
